<template>
    <div>
        <!-- Modal Seleção -->
        <div class="modal fade" id="selecaoModeloModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecione o Modelo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div @keydown.enter.prevent="selecionar_unico()">
                            <az-input   
                                ref="pesq_modelo"
                                sizing="sm"
                                icon="fa fa-search"
                                placeholder="Pesquisar..."
                                v-model="pesquisa"
                                @input="selecionado = null; selec_primeiro();"
                                @onArrowDown="onArrowDown"
                                @onArrowUp="onArrowUp" />
                        </div>

                        <table class="table table-sm border-0 table-responsive" v-if="lista_classes && lista_classes.length">
                            <tr>
                                <td class="text-nowrap">
                                    <a href="#" @click.prevent="classe == classe_selecionada ? classe_selecionada = '' : classe_selecionada = classe" v-for="(classe, icx) in lista_classes" :key="icx">
                                        <span class="badge mr-1" :class="classe == classe_selecionada ? 'badge-success' : 'badge-secondary'">
                                            {{ classe }}
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        </table>

                        <template v-if="!lista || !lista.length">
                            <az-empty-state icon="fa fa-file" msg="Nenhum modelo encontrado" :loading="loading" />
                        </template>

                        <template v-else>

                            <div class="form-row mb-0">
                                <div class="col col-12 col-md-6">
                                    <div class="card overflow-auto tamlista mb-0" style="padding: 0px; height: 60vh;">
                                        <div class="list-group">
                                            <button type="button" class="list-group-item list-group-item-action" v-for="(modelo, imx) in lista" :key="imx" @click="item_selecionado = modelo"
                                                :class="imx === selecionado ? 'active' : ''">
                                                {{ modelo.search }}
                                            </button>
                                        </div>

                                        <div v-if="lista && lista.length && ( ( selecionado === 0 ) || selecionado )" class="text-center mt-3 small text-muted">
                                            Pressione ENTER para incluir o modelo selecionado
                                            <div v-if="lista && lista.length > 1">
                                                {{ lista[selecionado].search }}
                                            </div> 
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-12 col-md-6">
                                    <div class="card overflow-auto tamlista mb-0 p-2" style="padding: 0px; height: 60vh;">
                                        <campos-formulario 
                                            :raiz="true"
                                            :value="item_selecionado ? item_selecionado.estrutura : []" 
                                            mode="view"
                                            v-if="item_selecionado && item_selecionado.estrutura && item_selecionado.estrutura.length" />

                                        <pre v-if="false">{{ item_selecionado }}</pre>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" :disabled="!item_selecionado" @click="selecionar(item_selecionado)">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue'
import AzEmptyState from '../../util/AzEmptyState.vue';
import CamposFormulario from '../consultorio/CamposFormulario.vue';

export default {
    data() {
        return { 
            modelos: null, 
            loading: false, 
            classe_selecionada: null, 
            pesquisa: "", 
            item_selecionado: null, 
            selecionado: null, 
        };
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        CamposFormulario, 
    },

    props: [
        'id_atendimento', 
        'id_procedimento', 
    ],
    
    computed: { 
        lista: function () { 

            if ( !this.modelos ) { 
                return [];
            }

            let reg = this.$util.getregex(this.pesquisa);

            return _.orderBy(
                this.modelos.filter(item => !this.classe_selecionada || ( item.js_classes && item.js_classes.includes(this.classe_selecionada)))
                    .filter(item => ( !this.pesquisa || reg.test(item.search) )),
                item => item.search.toUpperCase() == this.pesquisa.toUpperCase() ? 0 : 1
            );
            
        },

        lista_classes: function () { 
            if ( !this.modelos || !this.modelos.length ) { 
                return [];
            }

            return _.uniq(this.lista.flatMap(item => item.js_classes ? item.js_classes : [])).sort();
        }
    },

    watch: { 
        selecionado: function ( novo_valor ) { 
            this.mostrar_modelo_pelo_indice(novo_valor);
        },

        lista: function (newValue) { 
            if ( newValue && newValue.length === 1 ) { 
                this.selecionado = 0;
            }
        }
    },

    methods: { 
        selec_primeiro () { 
            this.$nextTick(() => { 
                this.onArrowDown(); 
            });
        },
        
        onArrowDown () {
            if ( this.selecionado === null ) {
                this.selecionado = 0;
                return;
            }

            if ( this.selecionado < this.lista.length - 1 ) { 
                this.selecionado ++;
            }
		},

		onArrowUp () {
			if ( this.selecionado > 0 ) {
				this.selecionado --;
			}
		},

        mostrar_modelo_pelo_indice ( indice ) { 
            if ( indice === null ) { 
                this.item_selecionado = null;
                return;
            }

            if ( this.lista[indice] ) { 
                this.item_selecionado = this.lista[indice];
            } else { 
                this.item_selecionado = null; 
            }
        },

        selecionar_unico () { 
            if ( this.lista.length === 1 ) { 
                this.selecionar(this.lista[0]);
            } else if ( this.selecionado !== null && this.lista[this.selecionado] ) { 
                this.selecionar(this.lista[this.selecionado]);
            } else { 
                this.$toast.add({
                    severity: 'info',
                    summary: 'Atenção',
                    detail: 'Selecione o modelo desejado.',
                    life: 5000
                });
            }
        },

        abrir () { 

            this.pesquisa = ""; 
            this.selecionado = null; 
            this.item_selecionado = null; 

            $('#selecaoModeloModal').modal('show');

            if ( this.modelos === null ) { 

                this.$util.load(this, { 
                    service: 'modelos', 
                    func: 'index', 
                    parms: {
                        mode: "selecao",
                        id_procedimento: this.id_procedimento,
                        id_atendimento: this.id_atendimento, 
                        simples: true, 
                        where: { fl_ativo: true }
                    },
                    loadTo: res => { 
                        this.modelos = res;
                    }
                });

            }

            setTimeout(() => {

                // localizar o input ou select dentro do modal e dar o foco nele usando jquery.
                let input = $('#selecaoModeloModal').find('input, select, textarea').first();

                if ( input.length ) { 
                    input.focus();
                }

            }, 500);

        },

        selecionar (modelo) { 
            this.$emit('selecionar', modelo);
            $('#selecaoModeloModal').modal('hide');
        }

    }

}
</script>

<style scoped>
.tamlista {
    height: 60vh !important; 
    overflow-y: auto;
}
</style>
